import { AlulaResponseData } from "@app/shared/databases/alula.database";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface AlulaReceiverBind {
    id?: string;
    dealerId: string;
    receiverId: string;
    receiverGroupId: string;
    priority: string;
    dateModified?: string;
    dateEntered?: string;
    createdBy?: string;
    modifiedBy?: string;
}

interface AlulaReceiverBindData extends AlulaReceiverBind {}

export class AlulaReceiverBindHelper {
    static dbEndpoint = "receivers/binds";
    static readonly importMap: ImportMap<AlulaReceiverBind, AlulaReceiverBindData> = [
        { i: "id", o: "id" },
        { i: "dealerId", o: "dealerId", skipExport: true },
        { i: "receiverId", o: "receiverId" },
        { i: "receiverGroupId", o: "receiverGroupId" },
        { i: "priority", o: "priority" },
        { i: "dateModified", o: "dateModified", skipExport: true },
        { i: "dateEntered", o: "dateEntered", skipExport: true },
        { i: "createdBy", o: "createdBy", skipExport: true },
        { i: "modifiedBy", o: "modifiedBy", skipExport: true },
    ];

    static fromDbObject(dbObject: AlulaResponseData): AlulaReceiverBind {
        const obj = ClassImporterExporter.importObject(dbObject.attributes, this.importMap);
        obj.id = dbObject.id;
        return obj;
    }

    static toDbObject(obj: AlulaReceiverBind): Partial<AlulaReceiverBindData> {
        return ClassImporterExporter.exportObject(obj, this.importMap, false);
    }
}
